export const ALLOWED_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'webp', 'svg'];

const INVALID_FORMAT_MESSAGE =
  "Formato de imagen no válido. Por favor, seleccione un archivo en formato JPG, JPEG, PNG, WEBP o SVG.";
const CORRUPT_IMAGE_MESSAGE =
  "La imagen está dañada o no es una imagen válida. Por favor, seleccione otro archivo.";

const getExtension = (file) => file.name.split('.').pop().toLowerCase();

const startsWith = (bytes, signature, offset = 0) =>
  signature.every((byte, i) => bytes[offset + i] === byte);

// Comprueba que los primeros bytes correspondan al formato que indica la extensión
const hasValidSignature = async (file, extension) => {
  const buffer = await file.slice(0, 1024).arrayBuffer();
  const bytes = new Uint8Array(buffer);

  switch (extension) {
    case 'jpg':
    case 'jpeg':
      return startsWith(bytes, [0xFF, 0xD8, 0xFF]);
    case 'png':
      return startsWith(bytes, [0x89, 0x50, 0x4E, 0x47, 0x0D, 0x0A, 0x1A, 0x0A]);
    case 'webp':
      // "RIFF" .... "WEBP"
      return startsWith(bytes, [0x52, 0x49, 0x46, 0x46]) && startsWith(bytes, [0x57, 0x45, 0x42, 0x50], 8);
    case 'svg':
      return new TextDecoder().decode(bytes).toLowerCase().includes('<svg');
    default:
      return false;
  }
};

// Comprueba que el navegador pueda decodificar la imagen completa
const canDecodeImage = (file) =>
  new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const img = new Image();

    const finish = (isValid) => {
      URL.revokeObjectURL(url);
      resolve(isValid);
    };

    img.onload = () => {
      if (!img.naturalWidth || !img.naturalHeight) {
        finish(false);
        return;
      }
      // decode() rechaza si los datos de la imagen están dañados
      if (typeof img.decode === 'function') {
        img.decode().then(() => finish(true), () => finish(false));
      } else {
        finish(true);
      }
    };
    img.onerror = () => finish(false);
    img.src = url;
  });

/**
 * Valida que el archivo sea una imagen permitida y que no esté corrupta.
 * @returns {Promise<{ isValid: boolean, message?: string }>}
 */
export async function validateImageFile(file) {
  const extension = getExtension(file);

  if (!ALLOWED_IMAGE_EXTENSIONS.includes(extension)) {
    return { isValid: false, message: INVALID_FORMAT_MESSAGE };
  }

  try {
    if (!(await hasValidSignature(file, extension)) || !(await canDecodeImage(file))) {
      return { isValid: false, message: CORRUPT_IMAGE_MESSAGE };
    }
  } catch (error) {
    console.error("Error al validar la imagen:", error);
    return { isValid: false, message: CORRUPT_IMAGE_MESSAGE };
  }

  return { isValid: true };
}
